import React from 'react';
import './TextButtonGroup.scss';

interface ButtonProps {
    label: string;
    buttonOptions?: any;
    unit: string;
    handleClick: (unit: any) => void;
    width?: any;
    required?: boolean;
}

const Button: React.FC<ButtonProps> = ({ label = "Select unit of measure", required, unit, buttonOptions = ['Imperial', 'Metric'], handleClick, width = '50%' }) => {
    return (
        <div className='flex flex-col w-full'>
            {label && <label className='text-neutral-25 pb-2 text-[14px]'>
                {label}
                {required && <span className="text-error-400 ml-1">*</span>}
            </label>}
            <div className="flex space-x-2 border border-darkcolor-400 rounded-lg button-right" style={{ width: width }}>
                {buttonOptions?.map((option: any) => {
                    const isSelected = unit === option?.label;
                    const isDisabled = option?.disabled;
                    return (
                        <div key={option?.id} className={`flex justify-center items-center gap-[8px] py-[10px] px-4 cursor-pointer ${isDisabled && !isSelected && 'disabled opacity-50 cursor-not-allowed'} w-${option?.width ? option?.width : "1/2"}`}
                            onClick={() => !isDisabled && handleClick(option?.label)}>
                            {option?.icon}
                            <button
                                key={option?.id}
                                disabled={isDisabled}
                                className={`rounded-r-lg transition-colors duration-200 ${isSelected
                                        ? isDisabled
                                            ? 'bg-darkcolor-700 text-primary-400 cursor-not-allowed'
                                            : 'bg-darkcolor-700 text-primary-400'
                                        : isDisabled
                                            ? 'bg-darkcolor-700 text-neutral-200 opacity-50 cursor-not-allowed'
                                            : 'bg-darkcolor-700 hover:bg-gray-200 text-neutral-25'
                                    }`}
                                onClick={() => !isDisabled && handleClick(option?.label)}
                            >
                                {option?.label}
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Button;